package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import battleships.shared.generated.resources.Res
import battleships.shared.generated.resources.ocean
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource

@Composable
fun MatchmakingScreen(
    opponentName: String = "",
    error: String? = null,
    onCancel: () -> Unit = {}
) {
    var dots by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        while (true) {
            dots = when (dots) {
                "" -> "."
                "." -> ".."
                ".." -> "..."
                else -> ""
            }
            delay(500)
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Image(
            painter = painterResource(Res.drawable.ocean),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Text(
                text = "MATCHMAKING",
                style = MaterialTheme.typography.displayMedium,
                color = Color.White
            )

            Spacer(Modifier.height(30.dp))

            Card(
                colors = CardDefaults.cardColors(containerColor = Color(0xAA001F3F)),
                border = BorderStroke(2.dp, Color.Cyan)
            ) {
                Column(
                    modifier = Modifier.padding(30.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    CircularProgressIndicator(color = Color.Cyan, strokeWidth = 5.dp)
                    Spacer(Modifier.height(20.dp))
                    Text(
                        text = "Searching for opponent$dots",
                        color = Color.White,
                        style = MaterialTheme.typography.titleMedium
                    )
                    Spacer(Modifier.height(12.dp))
                    Text(
                        text = "Scanning nearby fleets...",
                        color = Color.Cyan
                    )
                    error?.let {
                        Spacer(Modifier.height(12.dp))
                        Text(text = it, color = Color.Red)
                    }
                }
            }

            Spacer(Modifier.height(25.dp))

            OutlinedButton(
                onClick = onCancel,
                border = BorderStroke(1.dp, Color.Cyan)
            ) {
                Text("Cancel", color = Color.White)
            }
        }
    }
}
